_options$sectionIndex